<template>
  <ImgView
    v-if="brandLogo"
    :src="brandLogo"
    :alt="brand"
    class="w-max"
  />
</template>

<script lang="ts">

import { getBrandInfo } from '~~/helpers/brand';

export default defineComponent({
  name: 'ProductCardBrand',

  props: {
    brand: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const brandLogo = computed(() => getBrandInfo(props.brand)?.logo);

    return { brandLogo };
  
  },
});

</script>
